export const isFirstCharacterAlphaNumericLowercase = (
  value: string
): boolean => {
  return /^[a-z]/.test(value);
};

export const isLastCharacterAlphaNumericLowercase = (
  value: string
): boolean => {
  return /[a-z0-9]$/.test(value);
};

export const isAlphaNumericLowercaseOrHyphen = (value: string): boolean => {
  return /^[a-z](?:[a-z0-9]*(?:-[a-z0-9]+)*)?$/.test(value);
};
